import { AnimatePresence, motion } from 'motion/react'
import { useEffect, useState } from 'react'
import type { AnswerInputProps } from '../QuestionRenderer'

export function YesNoInput({ value, onChange, onSubmit }: AnswerInputProps<boolean>) {
  const [flash, setFlash] = useState<boolean | null>(null)

  function choose(next: boolean) {
    onChange(next)
    setFlash(next)
    window.setTimeout(() => {
      setFlash(null)
      onSubmit()
    }, 180)
  }

  useEffect(() => {
    function handleKey(event: KeyboardEvent) {
      if (event.key.toLowerCase() === 'y') choose(true)
      if (event.key.toLowerCase() === 'n') choose(false)
    }
    window.addEventListener('keydown', handleKey)
    return () => window.removeEventListener('keydown', handleKey)
  })

  return (
    <div className="relative grid gap-3 sm:grid-cols-2">
      <button
        type="button"
        onClick={() => choose(true)}
        className="min-h-24 border p-5 text-xl font-semibold"
        style={{
          background:
            value === true
              ? 'color-mix(in srgb, var(--form-accent,#10B981) 18%, transparent)'
              : 'color-mix(in srgb, var(--form-bg,#F8FAFC) 86%, white)',
          borderColor: value === true ? 'var(--form-accent,#10B981)' : '#10B98166',
          borderRadius: 'var(--form-radius,8px)',
          color: value === true ? 'var(--form-accent,#10B981)' : 'var(--form-answer,#334155)',
        }}
      >
        Yes
      </button>
      <button
        type="button"
        onClick={() => choose(false)}
        className="min-h-24 border p-5 text-xl font-semibold"
        style={{
          background:
            value === false
              ? 'rgb(255 241 242)'
              : 'color-mix(in srgb, var(--form-bg,#F8FAFC) 86%, white)',
          borderColor: value === false ? '#F43F5E' : '#F43F5E66',
          borderRadius: 'var(--form-radius,8px)',
          color: value === false ? '#BE123C' : 'var(--form-answer,#334155)',
        }}
      >
        No
      </button>
      <AnimatePresence>
        {flash !== null && (
          <motion.div
            className={`pointer-events-none fixed inset-0 ${flash ? 'bg-emerald-400' : 'bg-rose-400'}`}
            initial={{ opacity: 0.18 }}
            animate={{ opacity: 0 }}
            exit={{ opacity: 0 }}
          />
        )}
      </AnimatePresence>
    </div>
  )
}
